import React, { type JSX } from "react";
import SVG from "react-inlinesvg";
import { ChatLink } from "tsi-common-react/src/apps/chat/ChatLink";
import { RichText } from "tsi-common-react/src/common/RichText";
import { Trans } from "tsi-common-react/src/common/Trans";
import { FinancingPlan } from "tsi-common-react/src/models/financing";
import { usePageSetting } from "tsi-common-react/src/utils/settings";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import iconSpeechBubblesTalk from "../../svg/speech-bubbles-talk.svg";
import { BasketFinePrint } from "./BasketFinePrint";

interface IProps {
    plans: readonly FinancingPlan[];
    isMobile: boolean;
    cartID?: string;
}

export const BasketSidebarContent = (props: IProps) => {
    const contactURL = usePageURL("contact_us_form");
    const homeURL = usePageURL("home");
    const supportPhoneNumberLink = usePageSetting(
        "support_website_phone_number_link",
    );
    const supportPhoneNumberDisplay = usePageSetting(
        "support_website_phone_number_display",
    );
    const enableBasketSidebarQuestionsBlock = usePageSetting(
        "enable_basket_sidebar_questions_block",
    );
    const basketSidebarExtraContent = usePageSetting(
        "basket_sidebar_extra_content",
    );
    const ctaFmtString = t`<ChatLink>Chat</ChatLink> or <PhoneLink>Call</PhoneLink> and reference <BasketID></BasketID>.`;
    const msg = (
        <Trans
            fmtString={ctaFmtString}
            data={{
                ChatLink: (content) => (
                    <ChatLink
                        key="chat-link"
                        className="basket-summary__help--link"
                        chatOnlineText={content}
                        chatOfflineLink={contactURL || homeURL}
                    />
                ),
                PhoneLink: (content) => (
                    <strong key="phone-link">
                        {content}&nbsp;
                        <a href={supportPhoneNumberLink || ""}>
                            {supportPhoneNumberDisplay}
                        </a>
                    </strong>
                ),
                BasketID: () => <strong key="basket-id">{props.cartID}</strong>,
            }}
        />
    );

    let questionsBlock: JSX.Element | null = null;
    if (enableBasketSidebarQuestionsBlock) {
        questionsBlock = (
            <div className="basket-summary__help">
                <h3>
                    <SVG
                        className="basket-summary__help-icon"
                        src={iconSpeechBubblesTalk}
                        title={t`Speech Bubbles Icon`}
                    />
                    {t`Questions?`}
                </h3>
                <p>{msg}</p>
            </div>
        );
    }

    let finePrint: JSX.Element | null = null;
    if (props.isMobile) {
        finePrint = <BasketFinePrint plans={props.plans} />;
    }

    return (
        <div className="basket-summary__sidebar-content">
            {questionsBlock}
            <RichText html={basketSidebarExtraContent || ""} />
            {finePrint}
        </div>
    );
};
